<template>
  <div>
    <div class="row">
      <div class="col-3 text-center">
        <router-link to="/profile/business/advertising/priority/overview">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'overview',
                              'yellow-underline': endPath === 'overview' }">Overview</h4>
        </router-link>
      </div>
      <div v-if="adminComplete" class="col-3 text-center">
        <router-link to="/profile/business/advertising/priority/order">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'order',
                              'yellow-underline': endPath === 'order' }">Location</h4>
        </router-link>
      </div>
      <div v-if="adminComplete" class="col-3 text-center">
        <router-link to="/profile/business/advertising/priority/specialties">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'specialties',
                              'yellow-underline': endPath === 'specialties' }">Specialties</h4>
        </router-link>
      </div>
      <div v-if="adminComplete" class="col-3 text-center">
        <router-link to="/profile/business/advertising/priority/checkout">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'checkout',
                              'yellow-underline': endPath === 'checkout' }">Checkout</h4>
        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      endPath: null
    }
  },
  created () {
    this.setEndPath()
    console.log(this.adminComplete)
  },
  watch: {
    '$route' (to, from) {
      this.setEndPath()
    }
  },
  methods: {
    setEndPath () {
      var pathList = (this.$route.path).split('/')
      this.endPath = pathList[5]
    }
  },
  computed: {
    ...mapGetters('business', [
      'adminComplete'
    ])
  }
}
</script>

<style scoped>
.black-underline {
  border-bottom: solid;
}

.yellow-underline {
  border-bottom: solid;
  border-color: #feedaa;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/priority/PriorityAdvertising.vue